import {AutomationChoose} from '../../../../../reducer/model';
import {getLang, isRTL} from '../../../../../../../Localization';
import {BusinessRuleAction} from '../../../../../constants';
import {RecipientsType} from './enum';
import {RuleType} from '../../../../../enums';
import {languageTabs} from '../../AutomationActionToolbar/constants';
import {priority} from '@priority-software/priority-proto-api/lib/nform';
import {messageLangs} from './constants';

export const prepareFieldOptions = (
    fields: AutomationChoose[],
    englishFields: AutomationChoose[]
) => {
    return fields.map(field => {
        const englishField = englishFields.find(item => item.value === field.value);
        return {
            label: field.label,
            description: isRTL() ? '' : englishField?.label ? `<<${englishField?.label}>>` : '',
            value: englishField?.label || field.label
        };
    });
};

export const getMessageTemplate = state => {
    const searchMessage = Object.values(state.Messages).some(
        (message: priority.netitems.form.IAlertMessage) => {
            if (message.Message) {
                return true;
            }

            return false;
        }
    );

    return searchMessage;
};

export const getActiveMessageLang = (): string => {
    const curLang: string = getLang();
    const langTab = languageTabs.find(t => t.id === curLang) || languageTabs[0];
    return langTab.id;
};

export const getActiveSubjectMessage = (state): priority.netitems.form.IAlertMessage => {
    const initTabLang = getActiveMessageLang();

    if (
        state.CoverLetters[messageLangs[initTabLang]]?.Subject ||
        state.CoverLetters[messageLangs[initTabLang]]?.Message
    ) {
        return state.CoverLetters[messageLangs[initTabLang]];
    }

    if (
        state.Messages[messageLangs[initTabLang]]?.Subject ||
        state.Messages[messageLangs[initTabLang]]?.Message
    ) {
        return state.Messages[messageLangs[initTabLang]];
    }

    for (const langValue of Object.values(messageLangs)) {
        if (state.Messages[langValue]?.Subject || state.Messages[langValue]?.Message) {
            return state.Messages[langValue];
        }
    }

    return state.Messages['eng'];
};

export const getSupportedRecipients = (ruleType: RuleType, action: BusinessRuleAction) => {
    switch (action) {
        case BusinessRuleAction.TextMsg:
            return [
                RecipientsType.user,
                RecipientsType.group,
                RecipientsType.field,
                RecipientsType.phone
            ];
        case BusinessRuleAction.EmailMsg:
            return [
                RecipientsType.user,
                RecipientsType.group,
                RecipientsType.email,
                RecipientsType.field
            ];
        case BusinessRuleAction.PushNotification:
            return [RecipientsType.user, RecipientsType.group, RecipientsType.field];
        case BusinessRuleAction.AllowStatusChange:
            return [RecipientsType.user, RecipientsType.group, RecipientsType.field];
        case BusinessRuleAction.OpenTask:
            return ruleType === RuleType.bpm
                ? [RecipientsType.user, RecipientsType.field]
                : [RecipientsType.user];
        case BusinessRuleAction.AssignTo:
            return [RecipientsType.user, RecipientsType.group, RecipientsType.field];
        default:
            return [];
    }
};
